import { render, staticRenderFns } from "./CustomActions.vue?vue&type=template&id=72c1b645&scoped=true"
import script from "./CustomActions.vue?vue&type=script&lang=js"
export * from "./CustomActions.vue?vue&type=script&lang=js"
import style0 from "./CustomActions.vue?vue&type=style&index=0&id=72c1b645&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c1b645",
  null
  
)

export default component.exports